import PropTypes from "prop-types";
import "../../styles/ContractNotFound.scss";
import GapButton from "../gap-button/GapButton";

const ContractNotFound = (props) => {
    const { closedErrorDrawer, serviceNumber } = props;

    const formatPhoneNumber = () => {
        if (serviceNumber) {
            let cleaned = ('' + serviceNumber).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
            if (match) {
                cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
            }
            return cleaned;
        }
        return null;
    }

    const handleClick = () => {
        closedErrorDrawer();
    }
    return (
        <div className="contract-error__section">
            <i className="fa fa-exclamation-triangle fa fa-2x contract-error__icon"></i>
            <div className="contract-error__heading">We’re having trouble locating your contract.</div>
            <div className="contract-error__description"> We could not find a contract matching your information.  Please verify your information and try again.  If you feel this is an error, please call us at {formatPhoneNumber()} for assistance. </div>
            <div>
                <GapButton
                    buttonType="button"
                    id="drawer-error-button"
                    buttonClass="btn-contract-error cursor-pointer"
                    buttonLabel="Try Again"
                    onClick={handleClick}
                />
            </div>
        </div>
    )
};

ContractNotFound.propTypes = {
    closedErrorDrawer: PropTypes.func
}

export default ContractNotFound;